import official_customer_service from '@/common/mixins/official_customer_service'
const isIOS = wx.getSystemInfoSync().system.substring(0, 3).toLowerCase() === 'ios'
export default {
    mixins: [
        official_customer_service
    ],
    methods: {
        preview () {
            const img = this.qr
            wx.previewImage({
                current: img,
                urls: [img]
            })
        },
        copy () {
            this.copyCustomerWeixin()
        },
        saveQr () {
            wx.showLoading()
            wx.getImageInfo({
                src: this.qr,
                success: ({ path }) => this.saveFile(path),
                fail: wx.hideLoading
            })
        },
        saveFile (path) {
            wx.authorize({
                scope: 'scope.writePhotosAlbum',
                success: () => {
                    wx.saveImageToPhotosAlbum({
                        filePath: path,
                        success: (res) => {
                            wx.hideLoading()
                            if (isIOS) {
                                wx.showToast({
                                    icon: 'success',
                                    title: '图片已保存到相册'
                                })
                            } else {
                                wx.showModal({
                                    title: '图片保存成功',
                                    content: '文件路径：/Tencent/MicroMsg/WeiXin/',
                                    showCancel: false,
                                    confirmText: '我知道了'
                                })
                            }
                        },
                        fail: wx.hideLoading
                    })
                },
                fail: wx.hideLoading
            })
        }
    }
}
